import React, { ReactElement } from 'react';
import FormActions from './FormActions';
import FormStep, { FormStepProps } from './FormStep';

interface UseSteps {
  steps: React.ReactElement<FormStepProps>[];
  actions: React.ReactElement<FormStepProps>[];
}

export const useSteps = (children: React.ReactNode): UseSteps => {
  const steps: React.ReactElement<FormStepProps>[] = [];
  const actions: React.ReactElement[] = [];
  React.Children.forEach(children, (child) => {
    if (React.isValidElement(child)) {
      if (child.type === FormStep) {
        steps.push(child as ReactElement<FormStepProps>);
        return;
      }

      if (child.type === FormActions) {
        actions.push(child);
        return;
      }

      throw new Error('MultiStepForm children should be of type FormStep.');
    }
  });

  return {
    steps,
    actions,
  };
};
